var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMedforeldreWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5206_9370)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 4.75C10.5711 4.75 12.25 6.42893 12.25 8.5V23.5C12.25 25.5711 10.5711 27.25 8.5 27.25C6.42893 27.25 4.75 25.5711 4.75 23.5V8.5C4.75 6.42893 6.42893 4.75 8.5 4.75Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 4.75C25.5711 4.75 27.25 6.42893 27.25 8.5V23.5C27.25 25.5711 25.5711 27.25 23.5 27.25C21.4289 27.25 19.75 25.5711 19.75 23.5V8.5C19.75 6.42893 21.4289 4.75 23.5 4.75Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5929 6.1267L20.5929 6.12671L20.5962 6.12309C20.7804 5.91941 20.9498 5.74371 21.1246 5.60061C23.5646 3.61109 27.2411 5.35223 27.25 8.50112C27.2497 9.45904 26.8837 10.4156 26.1497 11.1496L18.4706 18.8287L18.4697 18.8296L16 21.291L13.5303 18.8296L13.5294 18.8287L5.85033 11.1496C5.11627 10.4155 4.75025 9.45888 4.75 8.50089C4.7591 5.34353 8.4348 3.60984 10.8759 5.60108L10.8818 5.60586L10.8878 5.61053C11.0706 5.75363 11.2315 5.91396 11.3795 6.09483L11.3929 6.11115L11.4071 6.1267L11.5156 6.24499C12.7147 7.56871 14.3597 8.2299 16 8.2299C17.6403 8.2299 19.2853 7.56872 20.4844 6.24502C20.4849 6.24442 20.4855 6.24382 20.486 6.24321L20.5929 6.1267Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5206_9370"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedforeldreWhite);
export default __webpack_public_path__ + "static/media/medforeldreWhite.f21398ee5025a0c63c4fce5321ef1f8b.svg";
export { ForwardRef as ReactComponent };